import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=170408d0&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=170408d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170408d0",
  null
  
)

export default component.exports